import LinkedIn from './Linkedin';
import Google from './Google';
import Signup from './Signup';

export default {
  LinkedIn,
  Google,
  Signup,
};
